import { useState, useRef } from "react";
import moment from "moment-timezone";
import { useTV } from "../../hooks/useTV";
import useGlobalStore from "../../store/global.store";

const Home = ({ device, countDownDate, timezone, currentDate }) => {
  const setShowSettings = useGlobalStore((state) => state.setShowSettings);

  const [settingsFocused, setSettingsFocused] = useState(false);
  const settingsRef = useRef(null);
  const { isTv } = useTV();

  const getDaysLeft = () => {
    const countdownEnd = moment(countDownDate).tz(timezone);
    const current = moment(currentDate).tz(timezone);
    // console.log(countdownEnd?.diff(current, 'days'))
    return countdownEnd?.diff(current, "days");
  };

  return (
    <div style={{ width: "100vw", height: "100vh", position: "relative" }}>
      <img
        src="/static/frame-top.png"
        alt=""
        style={{
          position: "fixed",
          top: isTv ? "-40px" : "0px",
          left: "0",
          width: "100vw",
          zIndex: 10,
        }}
      />

      <img
        src="/static/logo-white.png"
        alt=""
        style={
          isTv
            ? {
                zIndex: 20,
                position: "fixed",
                top: "3.0%",
                height: "100px",
                left: "50%",
                transform: "translateX(-50%)",
              }
            : {
                zIndex: 20,
                position: "fixed",
                top: "2%",
                height: "100px",
                left: "50%",
                transform: "translateX(-50%)",
              }
        }
      />

      {!isTv && (
        <button
          ref={settingsRef}
          tabIndex={0}
          onFocus={() => setSettingsFocused(true)}
          onBlur={() => setSettingsFocused(false)}
          onClick={() => setShowSettings(true)}
          style={{
            background: "transparent",
            border:
              settingsFocused && isTv
                ? "6px solid #3ADF3C"
                : "6px solid transparent",
            borderRadius: "50%",
            padding: "5px",
            cursor: "pointer",
            outline: "none",
            zIndex: 20,
            position: "fixed",
            top: "2%",
            right: "0%",
            transform: "translateX(-50%)",
          }}
        >
          <img
            src="https://img.icons8.com/ios-filled/500/FFFFFF/settings.png"
            alt="settings"
            style={{
              height: isTv ? "60px" : "50px",
            }}
          />
        </button>
      )}

      <div
        style={{
          position: "fixed",
          top: isTv ? "45%" : "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          color: "#12243F",
          width: "90vw",
        }}
      >
        <span
          style={
            isTv
              ? { fontFamily: "Lato", fontSize: "80px", fontWeight: "400" }
              : { fontFamily: "Lato", fontSize: "50px", fontWeight: "400" }
          }
        >
          WELCOME
        </span>
        <span
          style={
            isTv
              ? {
                  fontFamily: "Lato",
                  fontWeight: "700",
                  fontSize: "120px",
                }
              : {
                  fontFamily: "Lato",
                  fontWeight: "700",
                  fontSize: "80px",
                }
          }
        >
          {device.subscription.last_name} Family
        </span>
      </div>

      {getDaysLeft() >= 0 && (
        <div
          style={{
            position: "fixed",
            top: isTv ? "65%" : "68%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            justifyContent: "center",
            width: "100vw",
            color: "#12243F",
            fontFamily: "Lato",
          }}
        >
          <span
            style={{
              fontFamily: "Lato",
              fontSize: isTv ? "65px" : "45px",
              fontWeight: "600",
            }}
          >
            Check-In: {moment(countDownDate).format("MMMM DD, YYYY")}
          </span>
        </div>
      )}

      {/* {showSettings && <Settings device={device} />} */}
    </div>
  );
};

export default Home;
